module.exports = __webpack_public_path__ + "img/petstairs25.3841911e.jpg";